module.exports = __webpack_public_path__ + "img/7.ff011d1d.png";